import React from "react";
import { Box, Typography } from "@mui/material";
import SideBar from "../Component/SideBar";

export default function Dashboard() {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f4f6f8" }}>
      <SideBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          mt: { xs: "56px", sm: "64px" },
          width: "100%",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Dashboard
        </Typography>
      </Box>
    </Box>
  );
}
